import React, { useCallback } from 'react';
import { useLocalParticipant, useDailyEvent } from '@daily-co/daily-react';
import { useRecoilState, useSetRecoilState, useRecoilValue } from 'recoil';
import { topMessageAtom, playSoundAtom } from '../../State';
import { useTranslation } from 'react-i18next';

export default function ParticipantJoined({ leaveCall, isLive = false }) {
  //Daily系
  const localParticipant = useLocalParticipant();
  const { t } = useTranslation();
  const setTopMessageState = useSetRecoilState(topMessageAtom);
  const setSound = useSetRecoilState(playSoundAtom);

  //誰かがジョインした時のトリガー
  useDailyEvent(
    'participant-joined',
    useCallback((ev) => {
      //自分の参加した時間よりも、相手があとにきている場合のみ(joined_atは すでに Date関数型)
      if (
        localParticipant?.joined_at < ev.participant?.joined_at &&
        (ev.participant?.userData.userType == 'speaker' ||
          ev.participant?.userData.userType == 'owner')
      ) {
        //効果音を鳴らす
        setSound('play');
        //トップメッセージの送信
        setTopMessageState({
          type: 'joined',
          message: ev.participant?.user_name?.substring(0, 10) + t('top.joined the meeting'),
        });
      }
    }, []),
  );

  //オーナーがルームを離れたら、強制的に退出
  useDailyEvent(
    'participant-left',
    useCallback((ev) => {
      //ルームを離れたのがオーナーの場合
      if (ev.participant?.owner == true) {
        leaveCall();
      }
    }, []),
  );

  //レンダービュー
  return false;
}
